export default __webpack_public_path__ + "static/media/Triology3.9bf13909.jpg";